<template>
  <div class="container-fluid pb-4 f14 color-black">
    <div class="row mb-4">
      <div class="col-lg-12 col-xs-12">
        <h2 class="mt-3">CERTIFICAÇÃO</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">CERTIFICAÇÃO</span>
        <span class="color-red font-weight-bold">*</span>
        <div>
          <VueSuggestion
            v-model="extra_course.name"
            :searchURL="`${
              candidate_id
                ? `/recruiters/talent_banks/${candidate_id}/extra_courses/certifications`
                : `/candidates/extra_courses/certifications`
            }`"
            :selectedEl="extra_course"
            :whenSelected="
              (item) => {
                extra_course = item;
              }
            "
            classes="mt-1"
            placeholder="INFORME AQUI"
            responseDataName="extra_courses"
            style="text-transform: capitalize"
          />
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2"
          >INSTITUIÇÃO (SE APLICÁVEL)</span
        >
        <span class="color-red font-weight-bold">*</span>
        <VueSuggestion
          v-model="institution.name"
          :selectedEl="institution"
          :whenSelected="
            (item) => {
              institution = item;
            }
          "
          classes="mt-1"
          placeholder="INSTITUIÇÃO QUE VOCÊ ESTUDOU..."
          responseDataName="institutions"
          searchURL="/institutions"
          style="text-transform: capitalize"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-3 col-xs-12">
        <span
          :class="{ 'text-danger': errors.start_date }"
          class="font-weight-bold"
        >
          DATA DE INÍCIO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            v-model="start_date"
            v-mask="['##/####']"
            :class="{ 'is-invalid': errors.start_date }"
            class="vs__input"
            placeholder="mês/ano"
            type="text"
            @focus="errors.start_date = false"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span
          :class="{ 'text-danger': errors.end_date }"
          class="font-weight-bold text-nowrap mt-2"
        >
          DATA DE TÉRMINO OU PREVISÃO DE TÉRMINO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            v-model="end_date"
            v-mask="['##/####']"
            :class="{ 'is-invalid': errors.end_date }"
            class="vs__input"
            placeholder="mês/ano"
            type="text"
            @focus="errors.end_date = false"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-12 col-xs-12">
        <span class="font-weight-bold">DESCRIÇÃO</span>
        <div class="mt-1">
          <textarea
            v-model="description"
            class="full form-control"
            cols="30"
            rows="10"
            style="height: 100px; border-radius: 5px"
            maxlength="610"
          ></textarea>
          <div class="d-flex justify-content-end">
            <small class="form-text text-muted">{{ description.length }}/610</small>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 mt-2">
        <button
          class="btn-add-items-tb bg-purple color-white right"
          style="min-width: 300px"
          @click="createOrUpdate()"
        >
          SALVAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "components/VueSuggestion.vue";
import { format } from "date-fns";
import axios from "axios";

export default {
  props: ["certification_id", "candidate_id"],
  components: { VueSuggestion },
  mounted() {
    if (this.certification_id) {
      let url = `/candidates/extra_courses/${this.certification_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses/${this.certification_id}`;
      }
      axios.get(url).then((response) => {
        let certification = response.data.extra_course;

        this.extra_course.name = certification.name;
        this.institution.id = certification.institution_id;
        this.institution.name = certification.institution_name.toLowerCase();
        this.start_date = certification.start_date
          ? format(new Date(certification.start_date), "MM/yyyy")
          : "";
        this.end_date = certification.end_date
          ? format(new Date(certification.end_date), "MM/yyyy")
          : "";
        this.description = certification.description;
        this.type_activity = certification.type_activity;
      });
    }
  },
  data: () => ({
    start_date: "",
    end_date: "",
    description: "",
    type_activity: null,
    extra_course: {
      name: "",
    },
    institution: {
      id: 0,
      name: "",
    },
    name: "",
    errors: {
      start_date: false,
      end_date: false,
    },
  }),
  computed: {
    params() {
      let certification = {
        description: this.description,
        candidate_id: this.candidate_id,
        start_date: this.formatDate(this.start_date),
        end_date: this.formatDate(this.end_date),
        name: this.name,
        institution: this.institution.name.toLowerCase(),
        type_courses: 2,
        type_activity: this.type_activity,
      };
      return certification;
    },
  },
  methods: {
    createOrUpdate() {
      if (!this.validForm()) return;
      if (!this.validDate(this.start_date, "start_date")) return;
      if (!this.validDate(this.end_date, "end_date")) return;

      if (this.certification_id) {
        this.updateCertification();
        return;
      }
      this.createCertification();
    },
    createCertification() {
      let url = `/candidates/extra_courses/`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses/`;
      }
      axios
        .post(url, {
          extra_courses: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    updateCertification() {
      let url = `/candidates/extra_courses/${this.certification_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses/${this.certification_id}`;
      }
      axios
        .put(url, {
          extra_courses: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    sendFeedback(status) {
      if (!status) {
        this.$toast.error("Sinto muito, não foi possivel salvar.");
        return;
      }

      this.$toast.success("Certificação salva com sucesso!");
      eventBus.$emit("getCertifications");
      eventBus.$emit("updateInfo");
      this.$modal.hideAll();
    },
    validForm() {
      this.name = this.extra_course.name;
      let fields = [
        { name: "Curso", value: this.name },
        { name: "Instituição de ensino", value: this.institution.name },
        { name: "Ano de inicio", value: this.start_date },
        { name: "Ano de término", value: this.end_date },
      ];

      for (let field of fields) {
        if (field.value.length === 0) {
          this.$toast.error(`O campo "${field.name}" não pode ficar vazio.`);
          return false;
        }
      }

      return true;
    },
    validDate(dateStr, field) {
      if (dateStr.length === 0) {
        this.$toast.error("Por favor, preencha o campo corretamente.");
        this.errors[field] = true;
        return false;
      }

      let month = parseInt(dateStr.slice(0, dateStr.indexOf("/")));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      if (field === "start_date") {
        const start_date = new Date(year, month - 1, "01");
        const today = new Date();
        if (start_date > today) {
          this.errors[field] = true;
          return false;
        }
      }

      if (month === 0 || month > 12) {
        this.$toast.error("Data invalida.");
        this.errors[field] = true;
        return false;
      }

      if (year <= 1960 || year >= 2050) {
        this.$toast.error("Data invalida, insira um ano valido.");
        this.errors[field] = true;
        return false;
      }

      return true;
    },
    formatDate(dateStr) {
      let month = dateStr.slice(0, dateStr.indexOf("/"));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      return year.concat("/", month, "/01");
    },
  },
};
</script>
